import { isExternalUrl } from '@/utils/handlers/urlHandler';
import { Colors } from '@/utils/models/globalTypes';
import style from './slideItem.module.scss';
import { useLocale } from 'next-intl';
import LinkUrl from '../../../common/general/link/LinkUrl';
import CubesImage, { ScreenSizes } from '../../../common/general/cubes-image/CubesImage';
import { MediaType } from '@/projectRoot/api-client/interfaces/utils/global-enums';
import { SlideItemDto } from '@/projectRoot/api-client/interfaces/models/content/sitemap/blocks/Slider.dto';
import Container from '../../../common/general/container/Container';

interface Props {
    slide: SlideItemDto;
    linkColor?: Colors;
    classes?: string[];
    priority?: boolean;
    active?: boolean;
    activateItem?: () => void;
    fetchPriority?: boolean;
}

export const SlideItem = ({
    slide,
    linkColor = Colors.LIGHT,
    classes = [],
    priority = false,
    active,
    activateItem,
    fetchPriority = false
}: Props) => {
    const lang = useLocale();
    // const slideUrl = modelUrl(slide, lang);
    const displayBackground = (type: MediaType) => {
        switch (type) {
            case MediaType.VIDEO:
                return 'video';
            case MediaType.IMAGE:
                return 'image';
            default:
                return false;
        }
    }

    return (
        <LinkUrl
            classes={[style.slideItem, style[slide.align], style[slide.theme], classes.join(' '), active ? style.active : '']}
            noLink={!slide.is_full_clickable}
            url={''}
            onClick={activateItem}
        >
            {/* <h2 className={`${style.absoluteTitle} absoluteTitle`}>
                {slide.title ? slide.title : 'cta'}
            </h2> */}
            <div className={style.slideItemGradiant}></div>
            {
                displayBackground(slide.media_type) === MediaType.VIDEO 
                    ?
                    <div className={style.slideItemVideoBackground}>
                        <div className={style.video} dangerouslySetInnerHTML={{ __html: `<video src='${slide.video_desktop_url}' autoPlay muted loop playsinline></video>` }} />
                    </div>
                    :
                    <></>
            }
            {
                displayBackground(slide.media_type) === MediaType.IMAGE
                    ?
                    <div className={style.slideItemBackground}>
                        <CubesImage
                            imageNarrow={slide.image_mobile_url}
                            imageWide={slide.image_desktop_url}
                            excludeBreakPoints={[ScreenSizes.THUMB_120]}
                            placeholderImage='/'
                            alt={slide.title ?? 'slide-image'}
                            fetchPriority={fetchPriority ? 'high' : 'auto'}
                        />
                        {/* <Image src={slide.image_wide_url} layout='fill' alt={slide.title} /> */}
                    </div>
                    :
                    <></>
            }
            <div className={style.slideItemInner}>
                <Container>
                    <div className={style.content}>
                        {
                            slide.intro
                                ?
                                <p className={style.contentPretitle}>
                                    {slide.intro ?? ''}
                                </p>
                                :
                                <></>
                        }
                        {
                            slide.title
                            ?
                            <h2 className={`${style.contentTitle}`}>
                                {slide.title}
                            </h2>
                            : <></>
                        }
                        {
                            slide.description
                            ?
                            <div className={style.slideDesc} dangerouslySetInnerHTML={{ __html: slide.description ?? '' }} />
                            :
                            <></>
                        }
                        {
                            !slide.is_full_clickable && slide.call_to_action_items && slide.call_to_action_items.length > 0
                                ?
                                <div className={style.ctaItems}>
                                    {
                                        slide.call_to_action_items.map((item, index) => 
                                            <LinkUrl
                                                key={index}
                                                text={item.call_to_action_text != '' ? item.call_to_action_text : 'text'}
                                                url={item.call_to_action_url}
                                                reactRouter={!isExternalUrl(item.call_to_action_url)}
                                                backgroundColor={linkColor}
                                                classes={[`${style.link}`]}
                                            />
                                        )
                                    }
                                </div>
                                :
                                <></>
                        }
                    </div>
                </Container>
            </div>
        </LinkUrl>
    )
}

export default SlideItem;